// src/api/client.js
export async function apiRequest(url, options = {}) {
    try {
        // Get the access token from localStorage
        const token = localStorage.getItem('accessToken');

        // Prepare headers
        const headers = {
            'Content-Type': 'application/json',
            ...options.headers,
        };

        // Add Authorization header if token exists
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        // Merge headers into options
        const requestOptions = {
            ...options,
            headers,
        };

        console.log(`[API] Request to ${url}`, requestOptions);
        const response = await fetch(url, requestOptions);
        const text = await response.text();
        console.log(`[API] Response from ${url}`, response.status, text);

        if (!response.ok) {
            throw new Error(`Request failed: ${response.status} - ${text}`);
        }

        try {
            return JSON.parse(text);
        } catch {
            return text;
        }

    } catch (error) {
        console.error(`[API] Error: ${error.message}`);
        throw error;
    }
}
